import React, { useState } from 'react';
import { notify } from '../../Shared/toast';
import NavigationLinksHr from './NavLinkHr';

function NewEmployeeForm() {
  const initialForm = {
    fullName: '',
    designation: '',
    department: '',
    section: '',
    employmentType: 'Permanent',
    joiningDate: '',
    status: 'Active',
    village: '',
    upozila: '',
    district: '',
    notes: '',
  };

  const [formData, setFormData] = useState(initialForm);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    notify.success('Saved successfully');
    setFormData({ ...initialForm }); // reset with spread operator
  };

  return (
    <div className="p-6 space-y-6">
      <NavigationLinksHr />

      <div className="p-6 max-w-3xl mx-auto bg-white border shadow rounded-xl space-y-6">
        <h2 className="text-2xl font-semibold">New Employee Onboarding</h2>

        <form onSubmit={(e) => e.preventDefault()} className="space-y-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <input
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              placeholder="Full Name"
              className="border p-2 rounded"
            />

            <input
              name="designation"
              value={formData.designation}
              onChange={handleChange}
              placeholder="Designation"
              className="border p-2 rounded"
            />

            <select
              name="department"
              value={formData.department}
              onChange={handleChange}
              className="border p-2 rounded"
            >
              <option>Select Department</option>
              <option>Accounts</option>
              <option>Operations</option>
              <option>Kitchen</option>
            </select>

            <select
              name="section"
              value={formData.section}
              onChange={handleChange}
              className="border p-2 rounded"
            >
              <option>Select Section</option>
              <option>Finance</option>
              <option>Management</option>
              <option>House keeping</option>
            </select>

            <select
              name="employmentType"
              value={formData.employmentType}
              onChange={handleChange}
              className="border p-2 rounded"
            >
              <option>Permanent</option>
              <option>Contractual</option>
              <option>Intern</option>
            </select>

            <input
              type="date"
              name="joiningDate"
              value={formData.joiningDate}
              onChange={handleChange}
              className="border p-2 rounded"
            />

            <select
              name="status"
              value={formData.status}
              onChange={handleChange}
              className="border p-2 rounded"
            >
              <option>Active</option>
              <option>On Leave</option>
              <option>Resigned</option>
            </select>
            <select
              name="village"
              value={formData.village}
              onChange={handleChange}
              className="border p-2 rounded"
            >
              <option>Select Village</option>
              <option>Sandira</option>
              <option>Nilgonj</option>
              <option>Nodikul</option>
            </select>
            <select
              name="upozila"
              value={formData.upozila}
              onChange={handleChange}
              className="border p-2 rounded"
            >
              <option>Select Upozila</option>
              <option>Adamdighi</option>
              <option>Kalmakanda</option>
              <option>Naogaon Sadar</option>
            </select>
            <select
              name="district"
              value={formData.district}
              onChange={handleChange}
              className="border p-2 rounded"
            >
              <option>Select District</option>
              <option>Bogra</option>
              <option>Netrokona</option>
              <option>Naogaon</option>
            </select>
          </div>

          <textarea
            name="notes"
            value={formData.notes}
            onChange={handleChange}
            placeholder="Notes"
            rows="3"
            className="w-full border p-2 rounded"
          />

          <button
            type="button"
            onClick={handleSubmit}
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          >
            Save Employee
          </button>
        </form>
      </div>
    </div>
  );
}

export default NewEmployeeForm;
